import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'
import { CampaignDetailsParser } from './parsers/CampaignDetailsParser'

const responseParser = (data: any, metaInfo: any) => {
  const respData = data
  return CampaignDetailsParser(respData?.data, metaInfo)
}

const getCampaignDetails = (req: any, tokens: any, metaInfo: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: `${APIEndPoints.getCampaignDetails}`,
    method: 'POST',
    cache: false,
    body: req,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data, metaInfo)
  })
}

export { getCampaignDetails }
